import React from 'react';
import {Link} from 'react-router-dom';
import classes from './Navbar.module.css';
// import logo from '../logo.jpg';

function Navbar(props) {
    const navbar =()=>(
    
<nav className = {`navbar navbar-expand-lg ${classes.Navbar}`}>
    {/* <Link className={`navbar-brand ${classes.Link}`} to="/">
        <img style={{"border-radius":"50%","width":"50px","height":"50px"}} src={logo} alt="Nha thuoc Bich Thanh"/>
    </Link> */}
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon" style={{color:"white"}}><i className="fas fa-bars"></i></span>
    </button>

  <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className={`navbar-nav mr-auto ${classes.Navbarnav}`}>
            {/* <li className="nav-item active">
                <Link  className={`nav-link ${classes.Link}`} to="/">TRANG CHỦ <span className="sr-only">(current)</span></Link>
            </li> */}
            <li className="nav-item">
                <Link className={`nav-link ${classes.Link}`} to="#">THUỐC</Link>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                BỆNH
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                THỰC PHẨM CHỨC NĂNG
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                DƯỢC MỸ PHẨM
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                CHĂM SÓC CÁ NHÂN
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                SỐNG KHỎE
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                MANG THAI
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                NUÔI DẠY CON
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                DƯỢC LÝ
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                XÉT NGHIỆM
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
            <li className="nav-item dropdown">
                <Link className={`nav-link dropdown-toggle ${classes.Link}`} to="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                PHÁC ĐỒ ĐIỀU TRỊ
                </Link>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="#">Action</Link>
                <Link className="dropdown-item" to="#">Another action</Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="#">Something else here</Link>
                </div>
            </li>
        </ul>
  </div>
</nav>
    )
    return (
        <div>
            {navbar()}

        </div>

    );
}

export default Navbar;